import React from 'react';

interface ClueBadgeProps {
  id?: string;
  className?: string;
  size?: 'xs' | 'sm' | 'md';
}

export const ClueBadge: React.FC<ClueBadgeProps> = ({ id, className = '', size = 'xs' }) => {
  if (!id) return null;

  const sizeStyles = {
    xs: 'text-[8px] px-1.5 py-0.2',
    sm: 'text-[9px] px-2 py-0.4',
    md: 'text-[10px] px-2.5 py-0.5'
  };

  return (
    <span className={`inline-flex items-center font-mono font-black border rounded-md shadow-sm ${sizeStyles[size]} ${className} bg-zinc-900 text-zinc-400 border-zinc-700/50 tracking-tighter`}>
      {id}
    </span>
  );
};
